import React from 'react'
import { DashboardLayout } from '../layouts'
import { useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react';
import { useEffect } from 'react';
import { format } from 'date-fns';
import { CreateFieldWrapper } from '../containers';
import services from '../../ioc/services';
import { BasicButton } from '../components';
import ROUTES from '../../application/utils/Routes';
import { downloadFileFromBlob } from '../../application/utils/FileUtil';

function FormDetail() {

    const params = useParams();

    const navigate = useNavigate();

    const [formId] = useState(params.id);

    const [form, setForm] = useState(null)

    const [formFields, setFormFields] = useState([])

    const [file, setFile] = useState();

    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {

        services.api.form.getForm(formId)
            .then(res => {
                setForm(res)
                setFormFields(res.fields)
            })
            .catch(err => {
                services.alert.toast.error(err)
            })
    }, [formId])

    const downloadFormresponseFormat = () => {
        services.api.form.downloadFormResponseFormat(formId)
            .then(res => {
                downloadFileFromBlob(res, `${form.title}-response-format.csv`)
                services.alert.toast.success("Downloaded Successfully")
            })
            .catch(err => {
                services.alert.toast.error(err)
            })
    }

    const downloadFormResponses = () => {
        services.api.form.exportFormResponses(formId)
            .then(res => {
                downloadFileFromBlob(res, `${form.title}-responses.csv`)
                services.alert.toast.success("Downloaded Successfully")
            })
            .catch(err => {
                services.alert.toast.error(err)
            })
    }


    const handleFileChange = (e) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
        }
    };

    const navigateToFormResponses = () => {
        navigate(ROUTES.RESPONSES, {
            state: {
                "formId": formId
            }
        });
    }

    const handleResponseUpload = () => {

        if (!file) {
            services.alert.toast.error("Please Select a File")
            return
        }

        if (file.type != "text/csv") {
            services.alert.toast.error("Please Select a CSV File")
            setFile(null);
            return
        }

        if (isUploading) return;

        let formData = new FormData();

        formData.append("responsesFile", file);

        setIsUploading(true)

        services.api.form.uploadFormResponses(formId, formData)
            .then(res => {
                services.alert.toast.success("Responses Uploaded Successfully")
                setFile(null)
                navigateToFormResponses()
            })
            .catch(err => {

                services.alert.toast.error(err)
            })
            .finally(() => {
                setIsUploading(false)
            });

    }

    return (
        <DashboardLayout>

            {form &&

                <div className=' grid grid-cols-2 overflow-hidden h-full'>

                    <div className=' overflow-auto p-2'>
                        <div className='mb-3 font-bold'> {form.title}</div>
                        <p>{form.description}</p>
                        <p>{form.isPublic ? "Public" : "Not Public"}</p>
                        <p>Created By {form.createdBy}</p>
                        <p>Created {format(new Date(form.dateCreated), "PPP")}</p>

                        <div>
                            <h6>Assigned To</h6>
                            <div className='ml-6'>

                                {form.agentDetails.map(agent => <p>{agent.firstName} {agent.lastName}</p>)}
                            </div>
                        </div>

                        <div className=' '>
                            <h2 className=' text-center font-semibold text-lg'>Form Inputs</h2>
                            {formFields.map((formField, index) =>
                                <CreateFieldWrapper
                                    field={formField}
                                    position={index + 1}
                                    setFields={setFormFields}
                                    disableEdit={true} />
                            )}
                        </div>
                    </div>

                    <div>
                        <h2 className=' text-center font-semibold text-lg'>Form Actions</h2>
                        <div className=' flex flex-col items-center mt-6 gap-6'>
                            <BasicButton text="View Responses" onClick={navigateToFormResponses} />

                            <BasicButton text="Download Responses CSV" onClick={downloadFormResponses} />

                            <BasicButton text="Download Form CSV for Upload" onClick={downloadFormresponseFormat} />

                            <div class="flex items-center justify-center bg-grey-lighter">
                                <label class="w-64 flex flex-col items-center px-2 py-2 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-green-900">
                                    <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                        <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                    </svg>
                                    <span class="mt-2 text-base leading-normal">Upload Form Responses</span>
                                    <input type='file' class="hidden" onChange={handleFileChange} />
                                </label>
                            </div>

                            {file &&
                                <div className='mt-3'>
                                    <p className='mb-2 text-center'>{file.name}</p>
                                    <div className='flex gap-7 justify-center'>

                                        <button className="py-2 px-5 rounded-lg  border border-red-500" onClick={() => setFile(null)} > Cancel </button>

                                        <button disabled={isUploading} className="py-2 px-5 rounded-lg  bg-green-500 disabled:bg-green-200" onClick={handleResponseUpload}> Upload </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

            {!form && <div className='text-center'>Loading...</div>}
            {/* </div>  */}
        </DashboardLayout>
    )
}

export default FormDetail